import { changeEmail } from "api/services/user-service";
import { IChangeEmailRequest } from "api/models/request/IChangeEmailRequest";
import useWorkspaceApiCall from "./useWorkspaceApiCall";

export const useChangeEmail = () => {
    const { callAPI, loading } = useWorkspaceApiCall<IChangeEmailRequest, any>(changeEmail, 'profile.changeEmailSuccess', 'profile.changeEmailError');
    
    return { changeEmail: callAPI, changeEmailPending: loading };
};